import React from 'react';
import {View, StyleSheet, StyleProp, ViewStyle} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import {Svg, Path} from 'react-native-svg';
import {toPriceStr} from '@/utils';
import {useTranslation} from 'react-i18next';

const WonResult = ({
  awardAmount,
  style,
}: {
  awardAmount?: number;
  style?: StyleProp<ViewStyle>;
}) => {
  const {i18n} = useTranslation();
  return (
    <View style={[styles.container, theme.margin.topl, style]}>
      <Svg width={44} height={36} style={[styles.left]}>
        <Path
          d="M44.5 0H0.499996L10.9762 18L0.499996 36H44.5V0Z"
          fill={theme.basicColor.darkPrimary_1}
        />
      </Svg>
      <Svg width={44} height={36} style={[styles.right]}>
        <Path
          d="M0.5 0H44.5L34.0238 18L44.5 36H0.5V0Z"
          fill={theme.basicColor.darkPrimary_1}
        />
      </Svg>
      <View
        style={[
          theme.padding.lrs,
          theme.padding.tbxs,
          theme.background.primary,
          theme.flex.center,
        ]}>
        <Text color={theme.basicColor.white}>
          {i18n.t('game-page.label.guessRight')}
        </Text>
        <View style={[theme.flex.row, theme.flex.centerByCol]}>
          <Text color={theme.basicColor.white}>
            {i18n.t('game-page.label.total')}{' '}
          </Text>
          <Text
            color={theme.basicColor.white}
            size="large"
            fontFamily="fontInterBold">
            {toPriceStr(awardAmount)}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
    paddingBottom: 4,
  },
  right: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  left: {
    position: 'absolute',
    bottom: 0,
    left: 0,
  },
});

export default WonResult;
